































import Vue, { PropType } from 'vue'
export default Vue.extend({
  name: 'CpLinkArrow',
  inheritAttrs: false,
  props: {
    href: {
      type: String,
    },
    next: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
  },
})
